export default {
  profile: {
    name: 'Allen Johnson',
    headline: 'Senior Software QA Automation Engineer & Tech Lead',
    location: 'Davao City, Philippines',
    status: 'Actively seeking new professional opportunities',
    coreSkills: [
      'Java',
      'Kotlin',
      'Swift',
      'Javascript',
      'UI Testing',
      'API Testing',
      'Integration Testing',
      'Unit Testing',
      'Test automation frameworks',
      'Mobile testing',
      'JUnit',
      'Selenium WebDriver',
      'Cucumber',
      'TestCafe',
      'Tape',
      'Postman',
      'cURL',
      'Charles Proxy',
      'Espresso',
      'XCUITest',
      'Test planning',
      'Test case design',
      'Requirements gathering',
      'Git',
      'Jenkins',
      'JIRA',
      'Confluence',
      'Pivotal Tracker',
      'Continuous Integration',
      'Android Studio',
      'Xcode',
      'IntelliJ',
      'VS Code',
      'Google Antigravity',
      'Gemini CLI Code Assist',
    ],
  },
  projects: [
    {
      id: 'proj_1',
      title: 'Visual Node-Based Automation Editor',
      summary: 'A spatial IDE for constructing automated test workflows via an infinite node-graph interface, featuring Bezier curve wiring and JSON serialization.',
      tags: ['DOMQL3', 'State Management', 'SVG Render'],
      link: 'https://github.com/allenbrokeit/Automation-Editor',
      bentoSize: 'large',
    },
    {
      id: 'proj_2',
      title: 'Symbols Kanban',
      summary: 'A dynamic Kanban board built with Symbols and DOMQL, featuring drag-and-drop task management, priority levels, and an integrated calendar view.',
      tags: ['DOMQL3', 'State Management', 'Drag & Drop'],
      link: 'https://github.com/allenbrokeit/SymbolsToDoList',
      bentoSize: 'medium',
    },
    {
      id: 'proj_3',
      title: 'Symbols Tech Blog',
      summary: 'A professional technical blog built with the Symbols.app framework, featuring reactive state management, dynamic routing, and a centralized design system with HSL color tokens.',
      tags: ['DOMQL3', 'Design System', 'Dynamic Routing'],
      link: 'https://github.com/allenbrokeit/SymbolsTechBlog',
      bentoSize: 'large',
    },
    {
      id: 'proj_4',
      title: 'Automated QA Test Run Dashboard',
      summary: 'A transactional execution environment for regression runs with high-density data grids and real-time metric aggregation.',
      tags: ['SQLite', 'API Middleware', 'Data Visualization'],
      link: 'https://github.com/allenbrokeit/QA-Dashboard',
      bentoSize: 'medium',
    },
    {
      id: 'proj_5',
      title: 'Contractor Pipeline',
      summary: 'A CRM and project management dashboard designed for independent contractors to effectively track client engagements, manage project lifecycles, and monitor financial health.',
      tags: ['DOMQL3', 'CRM', 'Financial Tracking'],
      link: 'https://github.com/allenbrokeit/ContractorPipeline',
      bentoSize: 'large',
    },
  ],
}
